import { Outlet } from 'react-router-dom';
import { LanguageSync } from '../../../features/Translations/components/LanguageSync';

export function MeetLayout() {
	return (
		<>
			<LanguageSync />
			<Outlet />
		</>
	);
}
